import { PalMode } from '../components/PalAssessmentWrapper';

export const componentsConfigFn = (
  palMode: PalMode
): {
  showTimer: boolean;
  showHint: boolean;
  showMarks: boolean;
  showDifficulty: boolean;
  showResources: boolean;
  showStreak: boolean;
  showBloomLevel: boolean;
  showKnowledgeTree: boolean;
  showLearnometer: boolean;
  showLearnometerGain: boolean;
} => {
  switch (palMode) {
    case 'warmup':
      return {
        showTimer: false,
        showHint: false,
        showMarks: false,
        showDifficulty: true,
        showResources: false,
        showStreak: false,
        showBloomLevel: true,
        showKnowledgeTree: false,
        showLearnometer: false,
        showLearnometerGain: false,
      };
    case 'practice':
      return {
        showTimer: false,
        showHint: true,
        showMarks: false,
        showDifficulty: true,
        showResources: false,
        showStreak: true,
        showBloomLevel: true,
        showKnowledgeTree: true,
        showLearnometer: true,
        showLearnometerGain: true,
      };
    case 'challenge':
      return {
        showTimer: true,
        showHint: false,
        showMarks: true,
        showDifficulty: true,
        showResources: false,
        showStreak: true,
        showBloomLevel: true,
        showKnowledgeTree: true,
        showLearnometer: true,
        showLearnometerGain: true,
      };
    default:
      return {
        showTimer: false,
        showHint: false,
        showMarks: false,
        showDifficulty: true,
        showResources: false,
        showStreak: false,
        showBloomLevel: true,
        showKnowledgeTree: false,
        showLearnometer: false,
        showLearnometerGain: false,
      };
  }
};
